import React from 'react';
import styles from './Footer.module.css';
import FooterMenuList from './FooterMenuList';

interface MenuItem {
	href: string;
	title?: string;
	name?: string;
}

interface FooterMenuSectionProps {
	title?: string;
	items?: MenuItem[];
	customItems?: React.ReactNode;
}

const FooterMenuSection: React.FC<FooterMenuSectionProps> = ({
	title,
	items,
	customItems,
}) => {
	const hasContent = title || items || customItems;

	if (!hasContent) {
		return null;
	}

	return (
		<nav className={styles.footer__menu}>
			{title && <span className={styles.menuFooter__title}>{title}</span>}
			<ul>
				{customItems}
				{items && <FooterMenuList items={items} />}
			</ul>
		</nav>
	);
};

export default FooterMenuSection;
